import { IRewardItem } from '../State/reducers/score';

interface IAllItems {
    [key: string]: IItemConfig;
}

export interface IItemConfig {
    id: string;
    price: number;
    duration?: number;
    strength?: number;
    tileStrength?: number;
}

export interface ILockedItem {
    id: ItemIDs;
    unlockLevel: number;
    reward?: boolean;
}

export interface IReturningUserReward {
    item: IRewardItem;
    days: number;
}

export enum ItemIDs {
    COINS = 'Coins',
    HEART = 'Lives',
    HINT = 'Hint',
    HIGHLIGHT = 'Highlight',
    FIRECRACKER = 'Firecracker',
    MAGNET = 'Magnet',
    SHUFFLE = 'Shuffle',
    TIME = 'Time',
    COLLECTABLE_TOKEN = 'Token',
}

export const GameItemConfig: IAllItems = {
    heart: {
        id: 'heart',
        price: 100,
    },
    [ItemIDs.SHUFFLE]: {
        id: ItemIDs.SHUFFLE,
        price: 500,
    },
    [ItemIDs.TIME]: {
        id: ItemIDs.TIME,
        strength: 30,
        price: 300,
    },
    [ItemIDs.HINT]: {
        id: ItemIDs.HINT,
        price: 200,
    },
    [ItemIDs.MAGNET]: {
        id: ItemIDs.MAGNET,
        strength: 1,
        price: 300,
    },
    [ItemIDs.FIRECRACKER]: {
        id: ItemIDs.FIRECRACKER,
        strength: 3,
        tileStrength: 2,
        price: 400,
    },
    [ItemIDs.HIGHLIGHT]: {
        id: ItemIDs.HIGHLIGHT,
        duration: 10,
        price: 100,
    },
};

export const blockedItemReward: IRewardItem = { id: ItemIDs.COINS, val: 50, chance: 100 };
export const BOOSTER_LIST = [
    ItemIDs.HIGHLIGHT,
    ItemIDs.MAGNET,
    ItemIDs.FIRECRACKER,
    ItemIDs.SHUFFLE,
];
export const rewardCoinsBase = [10, 15, 25];

export const itemUnlockInfo: ILockedItem[] = [
    { id: ItemIDs.FIRECRACKER, unlockLevel: 6, reward: true },
    { id: ItemIDs.HIGHLIGHT, unlockLevel: 9, reward: true },
    { id: ItemIDs.COLLECTABLE_TOKEN, unlockLevel: 10, reward: false },
    { id: ItemIDs.HINT, unlockLevel: 15, reward: false },
    { id: ItemIDs.MAGNET, unlockLevel: 21, reward: true },
    { id: ItemIDs.SHUFFLE, unlockLevel: 16, reward: false },
    { id: ItemIDs.TIME, unlockLevel: 31, reward: false },
];

export const returningUserReward: IReturningUserReward[] = [
    {
        item: { id: ItemIDs.MAGNET, val: 1 },
        days: 3,
    },
    {
        item: { id: ItemIDs.FIRECRACKER, val: 1 },
        days: 5,
    },
    {
        item: { id: ItemIDs.SHUFFLE, val: 1 },
        days: 7,
    },
];

export const levelRewardItems: IRewardItem[] = [
    { id: ItemIDs.HIGHLIGHT, val: 1, chance: 20 },
    { id: ItemIDs.FIRECRACKER, val: 1, chance: 6 },
    { id: ItemIDs.TIME, val: 1, chance: 3 },
    { id: ItemIDs.SHUFFLE, val: 1, chance: 2 },
    { id: ItemIDs.MAGNET, val: 1, chance: 7 },
    { id: ItemIDs.HEART, val: 1, chance: 15 },
    { id: ItemIDs.COINS, val: 25, chance: 10 },
    { id: ItemIDs.COINS, val: 45, chance: 15 },
    { id: ItemIDs.COINS, val: 65, chance: 12 },
    { id: ItemIDs.COLLECTABLE_TOKEN, val: 2, chance: 4 },
    { id: ItemIDs.COLLECTABLE_TOKEN, val: 3, chance: 4 },
    { id: ItemIDs.COLLECTABLE_TOKEN, val: 4, chance: 2 },
];

export const giftCounterRewardItems: IRewardItem[] = [
    { id: ItemIDs.FIRECRACKER, val: 1, chance: 25 },
    { id: ItemIDs.MAGNET, val: 1, chance: 25 },
    { id: ItemIDs.COINS, val: 100, chance: 25 },
    { id: ItemIDs.COINS, val: 150, chance: 25 },
];

export const prizeWheelRewardItems: IRewardItem[] = [
    { id: ItemIDs.COINS, val: 75, chance: 24 },
    { id: ItemIDs.COINS, val: 100, chance: 25 },
    { id: ItemIDs.COINS, val: 1000, chance: 1 },
    { id: ItemIDs.HIGHLIGHT, val: 1, chance: 14 },
    { id: ItemIDs.FIRECRACKER, val: 3, chance: 2 },
    { id: ItemIDs.MAGNET, val: 1, chance: 10 },
    { id: ItemIDs.HEART, val: 1, chance: 20 },
    { id: ItemIDs.SHUFFLE, val: 1, chance: 4 },
];

export const sendRequestRewardItems: IRewardItem[] = [
    { id: ItemIDs.FIRECRACKER, val: 1, chance: 6.25 },
    { id: ItemIDs.HIGHLIGHT, val: 1, chance: 6.25 },
    { id: ItemIDs.TIME, val: 1, chance: 6.25 },
    { id: ItemIDs.SHUFFLE, val: 1, chance: 6.25 },
    { id: ItemIDs.MAGNET, val: 1, chance: 6.25 },
    { id: ItemIDs.HEART, val: 1, chance: 6.25 },
    { id: ItemIDs.COINS, val: 55, chance: 6.25 },
    { id: ItemIDs.COINS, val: 60, chance: 6.25 },
    { id: ItemIDs.COINS, val: 65, chance: 6.25 },
    { id: ItemIDs.COINS, val: 70, chance: 6.25 },
    { id: ItemIDs.COINS, val: 75, chance: 6.25 },
    { id: ItemIDs.COINS, val: 80, chance: 6.25 },
    { id: ItemIDs.COINS, val: 85, chance: 6.25 },
    { id: ItemIDs.COINS, val: 90, chance: 6.25 },
    { id: ItemIDs.COINS, val: 95, chance: 6.25 },
    { id: ItemIDs.COINS, val: 100, chance: 6.25 },
];

export const sendRequestGiftsRewardItems: IRewardItem[] = [
    { id: ItemIDs.FIRECRACKER, val: 1, chance: 6.25 },
    { id: ItemIDs.HIGHLIGHT, val: 1, chance: 6.25 },
    { id: ItemIDs.TIME, val: 1, chance: 6.25 },
    { id: ItemIDs.SHUFFLE, val: 1, chance: 6.25 },
    { id: ItemIDs.MAGNET, val: 1, chance: 6.25 },
    { id: ItemIDs.HEART, val: 1, chance: 6.25 },
    { id: ItemIDs.COINS, val: 15, chance: 6.25 },
    { id: ItemIDs.COINS, val: 20, chance: 6.25 },
    { id: ItemIDs.COINS, val: 25, chance: 6.25 },
    { id: ItemIDs.COINS, val: 30, chance: 6.25 },
    { id: ItemIDs.COINS, val: 35, chance: 6.25 },
    { id: ItemIDs.COINS, val: 40, chance: 6.25 },
    { id: ItemIDs.COINS, val: 45, chance: 6.25 },
    { id: ItemIDs.COINS, val: 50, chance: 6.25 },
    { id: ItemIDs.COINS, val: 55, chance: 6.25 },
    { id: ItemIDs.COINS, val: 60, chance: 6.25 },
];
